export default __webpack_public_path__ + "static/10-7f6b7fa559860c5fa828891017d7c57d.jpg";